module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_course01-fb7da1b129cf406ff66fbd2649ec8029.png";